<template>
  <div style="text-align: center;">
      <span class="info">{{status.info}}</span>
      <span v-if=" typeof status.message === 'string' && status.message.includes('Exception')"  style="color: red; font-weight: bold" class="info-exception"> Status: {{ status.message }}</span>
      <span v-else class="info-exception">Status: {{ status.message }}</span>
      <h3> Step 1: Upload Bank Export File </h3>

      <!-- Nav bar -->
      <div class="nav-bar">
         <div class="bank-upload">
            <form>
                <p for="files">Upload Bank Statements</p>
                <input type="file" id="files" name="files[]" accept=".csv" ref="bank_files" multiple v-on:change="handleFileUpload()"><br><br>
            </form>
        </div>

        <div class="progress-area" v-if="status.status == 'PROGRESS'">
            <div v-if="status.message ==''" class="loader"></div>
    
            <div v-else class="progress-area-block">
                <label for="file" class="progress-area-block-label">Progress: {{status.message}}% </label>
                <progress id="file" :value="status.message" max="100" style="height: 40px;"> {{status.message}}% </progress>
            </div>
        </div>

        <div class="buttons-area">
            <div>
                <button v-on:click='UploadFiles' :disabled="status.status == 'PROGRESS' || bank_files.length < 1">UPLOAD</button>
            </div>
        </div>
      </div>
  </div>
</template>

<script>
  import api from '../services/api';

  export default {
    data () {
      return {
        status: {},
        bank_files: [],
      }
    },
    methods: {
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },

        handleFileUpload(){
            console.log('fd')
            this.bank_files = this.$refs.bank_files.files;
        },

        UploadFiles: function (force) {
            let formData = new FormData();
            for( var i = 0; i < this.bank_files.length; i++ ){
                formData.append('bank_file[' + i + ']', this.bank_files[i]);
            }
            let url = '/upload_bank_files';
            if (force) {
                url += '?force=true';
            }
            api.post(url, formData,
            {
                headers: {
                'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                if (response.status_code)
                this.bank_files = [];
                console.log('Success!');
                this.$router.push({name:'UploadRemittance'})
            })
            .catch((e) => {
                if (e.response && e.response.status === 409 && e.response.data.code === 'DUPLICATE_FILE') {
                    if (confirm('This file is already being processed in another session. Do you want to reprocess it?')) {
                        this.UploadFiles(true);
                    }
                } else {
                    console.log(e);
                }
            });
        },

        async getResult() {
            while (1 != this.state) {
                try {
                    let response = await api.post('/get_result');
                    
                    if (response.status == 200) {
                        this.status = response.data
                        this.invoices = response.data['data'] ?? [];
                    }
                } catch (error) {
                    console.log(error);
                }
                await this.sleep(200000000)
            }
        }
    },
    mounted() {
      this.getResult()
    },
    name: 'ResultPage',
  }
</script>

<style scoped>
    h3 {
        text-align: left;
    }
    .nav-bar {
        width: 900px;
        margin: 0 auto;
        padding: 16px 32px;
        background: rgb(219, 227, 230);
        border: 0;
        border-radius: 4px;
    }

    .info {
        position: absolute;
        left: 8px;
        top: 8px;
        font-weight: bold;
        color: grey
    }

    .info-exception {
        position: absolute;
        left: 8px;
        top: 24px;
        font-weight: bold;
        color: grey
    }
    
    .router-link {
        text-decoration: none;
    }

    a {
        text-decoration: none;
    }

    .progress-area {
        display: flex;
        justify-content: center;
        align-items: center; 
    }

    .progress-area-block {
        display: flex;
        align-items: center; 
    }

    .progress-area-block-label {
        padding-right: 15px;
        font-weight: bold;
    }

    button {
        line-height: 38px; 
        margin: 10px;
        text-align: center; 
        padding: 0 30px; 
        vertical-align: middle; 
        font-size: .875rem; 
        color: #fff; 
        background-color: #1e87f0; 
        border: 1px solid transparent;
        font-weight: bold;
        border-radius: 4px;
        cursor: pointer;
    }

    .buttons-area {
        text-align: right;
    }

    button:disabled {
        background-color: #cccccc;
        color: #707070;
        cursor: default;
    }

    table {
        border-collapse: collapse;
        margin: 25px auto;
        font-size: 0.9em;
        font-family: sans-serif;
        width: 932px;
        box-shadow: 0 0 20px rgba(0, 0, 0, 0.15);
        table-layout:fixed;
    }

    th, td {
        padding: 12px 15px;
        word-wrap: break-word;
    }

    thead tr {
        background-color: #1e87f0;
        color: #ffffff;
        text-align: center;
        padding: 25px;
    }

    .loader {
        border: 8px solid #f3f3f3; /* Light grey */
        border-top: 8px solid #3498db; /* Blue */
        border-radius: 50%;
        width: 60px;
        height: 60px;
        animation: spin 2s linear infinite;
        justify-content: center; 
        display: inline-block;
    }

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
</style>